// Layout route that keeps Header mounted across route changes so the logo + nav don't flicker on navigation.

import React from 'react';
import { Outlet } from 'react-router';
import Header from '../components/navigation/Header';
import { HomeNavAccentProvider } from '../contexts/HomeNavAccentContext';

const HeaderLayout: React.FC = () => {
  return (
    <HomeNavAccentProvider>
      <Header />
      <Outlet />
    </HomeNavAccentProvider>
  );
};

export default HeaderLayout;
